import { useEffect } from 'react';

type Props = {
  href: string;
};

function ExternalRedirect({ href }: Props) {
  useEffect(() => window.location.replace(href));
  return <div>Redirecting...</div>;
}

export default ExternalRedirect;
